export default "__VITE_ASSET__Shk5kIH3__"